import React from 'react';
import { EeTextValue } from 'pages/Scenarios/components/EeTextValue';

export function EeCard(props: any) {
  return (
    <div className="d-flex flex-column bg-white border-bottom shadow-sm p-4 w-100 lens-section">
      <div className="d-flex flex-column">
        <h3>{props.title}</h3>
        <div>
          {props?.cardInfo?.map((c: any, i: number) => (
            <EeTextValue
              key={i}
              title={c.title}
              value={c.content}
              formatProps={c.formatProps}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
